import { StripedDataGrid } from 'ui-component/grids';
import { LineItemsCustomFooter, CustomNoRowsOverlay, LineItemsCustomToolbar, LineItemsCustomToolbarProps } from './components';
import { Typography } from '@mui/material';
import GridWithInlineEdit from 'ui-component/grids/GridWithInlineEdit';
import { GridColDef } from '@mui/x-data-grid';

export type LineItemsGridSkeletonProps = {
    gridRef: React.MutableRefObject<any>;
    handleProcessCreate: (newRow: Record<string, any>) => Promise<Record<string, any> | undefined>;
    handleProcessUpdate: (newRow: Record<string, any>) => Promise<Record<string, any> | undefined>;
    onDeleteLineItem: (id: number) => void;
    loadingData: boolean;
    columns: GridColDef[];
    rows: Record<string, any>[];
    showCustomNoRowsOverlay?: boolean;
    handleAddClick: () => void;
    isAllowedToEditLineItems: boolean;
    isAllowedToExportLineItems: boolean;
    handleOnRefetch: () => Promise<void>;
    baseIndexForTheCreation: number;
    recordTypeId: number;
    recordId?: number;
    shouldImport: boolean;
    shouldShowHistory?: boolean;
    toolbarProps?: any;
    cleanSortModel?: boolean;
};

const LineItemsGridSkeleton = ({
    gridRef,
    handleProcessCreate,
    handleProcessUpdate,
    onDeleteLineItem,
    loadingData,
    columns,
    rows,
    showCustomNoRowsOverlay,
    handleAddClick,
    isAllowedToEditLineItems,
    isAllowedToExportLineItems,
    handleOnRefetch,
    baseIndexForTheCreation = 1,
    recordTypeId,
    recordId,
    shouldImport,
    shouldShowHistory = true,
    toolbarProps,
    cleanSortModel
}: LineItemsGridSkeletonProps) => (
    <GridWithInlineEdit
        ref={gridRef}
        GridComponent={StripedDataGrid}
        density="compact"
        onCreate={handleProcessCreate}
        onUpdate={handleProcessUpdate}
        onClickDelete={onDeleteLineItem ? (row: any) => onDeleteLineItem(row.id) as any : undefined}
        loading={loadingData}
        columns={columns}
        fieldToFocus={columns[0]?.field || ''}
        initialRows={rows}
        sx={{
            '& .MuiTablePagination-toolbar': { py: 0 },
            '& .MuiTablePagination-selectLabel, & > .MuiTablePagination-displayedRows': { margin: 0 },
            '.MuiDataGrid-columnHeaders, .MuiDataGrid-pinnedColumnHeaders': { backgroundColor: '#F5F6F7 !important' }
        }}
        gridComponents={{
            Footer: LineItemsCustomFooter,
            NoRowsOverlay: showCustomNoRowsOverlay ? () => <CustomNoRowsOverlay onAddNewItem={handleAddClick} /> : undefined
        }}
        slotProps={{
            footer: {
                onClickNew: handleAddClick
            } as any
        }}
        customToolbar={LineItemsCustomToolbar}
        customToolbarProps={
            {
                shouldEdit: isAllowedToEditLineItems,
                shouldExport: isAllowedToExportLineItems,
                lineItemsApiRef: gridRef.current?.apiRef,
                refetchGrid: handleOnRefetch,
                baseIndexForTheCreation,
                recordTypeId,
                recordId,
                shouldImport,
                ...(toolbarProps && toolbarProps)
            } as LineItemsCustomToolbarProps
        }
        CustomRenderHeaderActions={(params: any) => (
            <Typography fontSize="16px" fontWeight={700} color="#000000">
                {params.colDef.headerName}
            </Typography>
        )}
        recordId={recordId}
        disabledReordering
        disabledCheckboxSelection
        shouldEdit={isAllowedToEditLineItems}
        shouldExport={isAllowedToExportLineItems}
        autosizeColumns
        pinnedInternalAction="right"
        shouldShowHistory={shouldShowHistory}
        cleanSortModel={cleanSortModel}
    />
);

export default LineItemsGridSkeleton;
